/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export let ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError;
(function (_ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError) {})(ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError || (ComHubspotSalesDocumentsModelsErrorAbstractDocumentImportError = {}));
export let ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError;
(function (_ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError) {})(ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError || (ComHubspotSalesDocumentsModelsErrorAbstractDocumentUploadError = {}));
export const uploadDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'uploadDocument',
  auth: 'app',
  fingerprint: 'BbChRwops6oKBDFE3ZxLZsfEoM5ykBrs',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const importDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'importDocument',
  auth: 'app',
  fingerprint: 'Rr6ZcBr1PkVxM9CA99W2e8DFUui7NTaI',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocument',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOS4N5M1v_pYgpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'updateDocument',
  auth: 'app',
  fingerprint: 'w6Pe8Q0uv124N5M1v_pYgiZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'deleteDocument',
  auth: 'app',
  fingerprint: '1fwnhKH-eQmOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUploadProgressRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getUploadProgress',
  auth: 'app',
  fingerprint: 'aCRaUXKTx8AE8UA5VQQqJCZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDocumentUsageRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentUsage',
  auth: 'app',
  fingerprint: 'AAAAAAAAAABM7sVFmXbvTpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDocumentDownloadUrlRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentDownloadUrl',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOSJfDg5qJEAAiZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDocumentPdfDownloadUrlRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'getDocumentPdfDownloadUrl',
  auth: 'app',
  fingerprint: 'mjfnwTdgYOSJfDg5qJEAAiZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const shareDocumentRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'shareDocument',
  auth: 'app',
  fingerprint: 'twWAPz8CoIG95rF2c6lhdSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const moveDocumentsRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'moveDocuments',
  auth: 'app',
  fingerprint: 'l3ayoJ9kllMSm0EFg5ED9CZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchDeleteDocumentsRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'batchDeleteDocuments',
  auth: 'app',
  fingerprint: 'If7V9r8XdzKOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDocumentBrandRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'updateDocumentBrand',
  auth: 'app',
  fingerprint: 'arKrFmY98g2OUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const batchUpdateDocumentBrandRpc = {
  serviceName: 'com.hubspot.sales.documents.rpc.SalesDocumentsDocumentService',
  rpcName: 'batchUpdateDocumentBrand',
  auth: 'app',
  fingerprint: 'o751f9p1PIaOUe2e_r4XmSZvnTu4aPTm',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};